'use client';

import Icon from '@/components/ui/AppIcon';

interface ServiceFilterBarProps {
  selectedCategory: string;
  selectedIndustry: string;
  searchQuery: string;
  onCategoryChange: (category: string) => void;
  onIndustryChange: (industry: string) => void;
  onSearchChange: (query: string) => void;
}

export default function ServiceFilterBar({
  selectedCategory,
  selectedIndustry,
  searchQuery,
  onCategoryChange,
  onIndustryChange,
  onSearchChange,
}: ServiceFilterBarProps) {
  const categories = [
    'All Services',
    'Telecom Infrastructure',
    'Electrical Systems',
    'Maintenance & Support',
    'Project Management',
  ];

  const industries = [
    'All Industries',
    'Telecommunications',
    'Government',
    'Industrial',
    'Commercial',
  ];

  return (
    <div className="bg-card rounded-lg shadow-subtle p-6 mb-8">
      <div className="flex flex-col lg:flex-row gap-4">
        <div className="flex-1">
          <label className="block text-xs font-headline font-semibold text-textPrimary mb-2">
            Search Services
          </label>
          <div className="relative">
            <Icon
              name="MagnifyingGlassIcon"
              size={18}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-textSecondary"
            />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Search by service name or keyword..."
              className="w-full pl-10 pr-4 py-2 border border-input rounded-md text-sm font-body text-textPrimary placeholder:text-textSecondary focus:outline-none focus:ring-2 focus:ring-ring"
            />
          </div>
        </div>

        <div className="lg:w-64">
          <label className="block text-xs font-headline font-semibold text-textPrimary mb-2">
            Service Category
          </label>
          <div className="relative">
            <Icon
              name="FunnelIcon"
              size={18}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-textSecondary pointer-events-none"
            />
            <select
              value={selectedCategory}
              onChange={(e) => onCategoryChange(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-input rounded-md text-sm font-body text-textPrimary focus:outline-none focus:ring-2 focus:ring-ring appearance-none bg-card cursor-pointer"
            >
              {categories.map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>
            <Icon
              name="ChevronDownIcon"
              size={18}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-textSecondary pointer-events-none"
            />
          </div>
        </div>

        <div className="lg:w-64">
          <label className="block text-xs font-headline font-semibold text-textPrimary mb-2">
            Target Industry
          </label>
          <div className="relative">
            <Icon
              name="BuildingOfficeIcon"
              size={18}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-textSecondary pointer-events-none"
            />
            <select
              value={selectedIndustry}
              onChange={(e) => onIndustryChange(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-input rounded-md text-sm font-body text-textPrimary focus:outline-none focus:ring-2 focus:ring-ring appearance-none bg-card cursor-pointer"
            >
              {industries.map((industry) => (
                <option key={industry} value={industry}>
                  {industry}
                </option>
              ))}
            </select>
            <Icon
              name="ChevronDownIcon"
              size={18}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-textSecondary pointer-events-none"
            />
          </div>
        </div>
      </div>
    </div>
  );
}